export enum OfferRequestOptionEnum {
  REQUEST_PHOTO = "request-photo",
  REQUEST_PACKAGING = "request-packaging",
  REQUEST_QUANTITY = "request-quantity",
  REQUEST_HOLD = "request-hold",
}
